import React from 'react'
import PageHero from '../components/PageHero'
import PageLayout from '../components/PageLayout'
import SignatureEvent from '../components/SignatureEvent'

const SignatureEventsPage: React.FC = () => {
    return (
        <PageLayout>
            <PageHero title="Signature Events" image="./img/afroconheader.jpg" imageAlt="AfroCon community celebration" />
            <section className="signature-events">
                <div className="signature-events__intro">
                    <p className="lead text-muted mb-0">We host events throughout the year.</p>
                </div>

                <SignatureEvent
                    title="Black Fae Day"
                    mediaSide="left"
                    image={{
                        src: './img/events/black-fae-day.png',
                        alt: 'Black Fae Day event poster',
                    }}
                    videos={[
                        {
                            type: 'youtube',
                            src: 'https://www.youtube.com/embed/VwLUcn4RK4I',
                            title: 'Black Fae Day YouTube Short',
                        },
                    ]}
                    description={
                        <p>
                            Black Fae Day is a celebration of Black people in fantasy. All fairies, elves, mermaids, and folk
                            are invited to join in as we frolic, munch, and celebrate all things magical in the park.
                            Professional photographs will be taken to capture the day. More information to come!
                            #blackfaeday
                        </p>
                    }
                    meta={
                        <>
                            Saturday, May 8th 2027 | 12pm-5pm
                            <br />
                            Miller Park Pavilion, 2707 Redick Avenue, Omaha, NE 68111
                        </>
                    }
                />

                <SignatureEvent
                    title="Juneteenth Steampunk Tea Party Weekend 2026"
                    mediaSide="right"
                    videos={[
                        {
                            type: 'youtube',
                            src: 'https://www.youtube.com/embed/OWVctKLa6FQ?si=fdF5yUzWN0_Hn0S7',
                            title: 'Juneteenth Steampunk highlight video',
                        },
                        {
                            type: 'youtube',
                            src: 'https://www.youtube.com/embed/f73_9rG8rcc',
                            title: 'Juneteenth Steampunk recap video',
                        },
                    ]}
                    meta={
                        <>
                            June 12th–13th 2027
                            <br />
                            More information coming soon
                        </>
                    }
                />

                <SignatureEvent
                    title="AfroCon"
                    mediaSide="left"
                    image={{
                        src: './img/events/2026/freedomlab2026.png',
                        alt: 'Freedom Lab 2026 event poster',
                    }}
                    videos={[
                        {
                            type: 'local',
                            src: './video/AfroconPromo.mp4',
                            title: 'AfroCon promo video',
                        },
                    ]}
                    description={
                        <p>
                            AfroCon is a day-long comic and gaming convention, with community conversations, workshops and
                            vendors. It is a 1-2 day festival of nerd culture and black culture with artists, vendors, food
                            trucks, workshops, demonstrations, ESports games + tournaments, board gaming, cosplay and
                            conference style community panels and conversations on a variety of topics.
                        </p>
                    }
                    meta={
                        <>
                            Saturday, October 9th and 10th, 2026
                            <br />
                            MCC Fort Omaha Campus, CAET Building #24
                        </>
                    }
                    cta={{
                        href: 'https://www.eventbrite.com/e/afrocon-2026-tickets-1979103935146?aff=ebdsoporgprofile',
                        label: 'Buy Tickets',
                    }}
                />
            </section>
        </PageLayout>
    )
}

export default SignatureEventsPage
